// Defoalt is for HRM API
export const environment = {
  baseUrl: 'https://api.ebill.so:3223/api',
  url: 'https://api.ebill.so:3223/',
  production: true
};